module.exports = __webpack_public_path__ + "img/UploadPrices.d53f1810.png";